import React, { Component } from 'react';
import IconButton from 'material-ui/IconButton';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { connect } from 'react-redux';

import DropSimple from './DropSimple';
import * as DesignerState from '../../../state/reducer/designer/designer';
import * as Utils from '../../../lib/designerUtils';
import Console from '../../../lib/debug';

export class RepTable extends Component {
    componentDidUpdate() {
        if (this.props.schemeUpdated) {
            this.$setsDrop.focus();
        }
    }

    changeExSetCount(newValue) {
        let dispatch = this.props.dispatch;
        let block = this.props.block;
        let exercise = this.props.exercise;
        DesignerState.updateSetNum(dispatch, block, exercise, newValue.value);
    }

    selectOnClick(event) {
        event.target.select();
    }

    updateParamType(paramNumber, newValue) {
        let dispatch = this.props.dispatch;
        let exercise = this.props.exercise;

        DesignerState.updateExerciseParamType(
            dispatch,
            exercise,
            paramNumber,
            newValue.id
        );
    }

    updateValue(event, type, paramName, paramPosition, dataPosition) {
        let dispatch = this.props.dispatch;
        let exercise = this.props.exercise;

        let value = Utils.parseTableValue(type, event.target.value);
        const paramCount = exercise.param_count;

        if (dataPosition < paramCount) {
            for (let i = dataPosition; i <= paramCount; i++) {
                const key = 'param_' + paramPosition + '_data_' + i;
                exercise[key] = value;
            }
        }

        const updatedSetExercise = DesignerState.updateExerciseValueState(
            dispatch,
            exercise,
            paramName,
            value
        );
        DesignerState.saveUpdatedExerciseValuesDebounced(updatedSetExercise);
    }

    onKeyDown(e, param, num) {
        let nextInput = null;
        let exercise = this.props.exercise;
        if (e.key === 'Enter') {
            nextInput = this.getNextInputOnEnter(param, exercise, num);
        }
        if (
            e.key === 'ArrowDown' ||
            e.key === 'ArrowUp' ||
            e.key === 'ArrowLeft' ||
            e.key === 'ArrowRight'
        ) {
            nextInput = this.getNextInputOnArrow(param, exercise, num, e.key);
        }
        // eslint-disable-next-line
        if (this.refs[nextInput]) {
            // eslint-disable-next-line
            this.refs[nextInput].focus();
            setTimeout(() => {
                // eslint-disable-next-line
                this.refs[nextInput].select();
            }, 100);
        }
    }

    getNextInputOnEnter(param, exercise, num) {
        let nextRow = num + 1;
        let nextColumn = parseInt(param.replace('p', ''));
        let nextInput = `${exercise.key}_p${nextColumn}_${nextRow}`;
        // eslint-disable-next-line
        if (!this.refs[nextInput] || this.refs[nextInput].disabled) {
            nextRow = num;
            nextInput = `${exercise.key}_p${nextColumn}_${nextRow}`;
        }
        return nextInput;
    }

    getNextInputOnArrow(param, exercise, num, direction) {
        let nextRow = num;
        let nextColumn = parseInt(param.replace('p', ''));
        switch (direction) {
            case 'ArrowUp':
                nextRow = num === 0 ? num : num - 1;
                break;
            case 'ArrowDown':
                nextRow = num + 1;
                break;
            case 'ArrowLeft':
                if (nextColumn === 1 && nextRow !== 1) {
                    nextColumn = 2;
                    nextRow = nextRow - 1;
                } else {
                    nextColumn = 1;
                }
                break;
            case 'ArrowRight':
                if (nextColumn === 2) {
                    nextColumn = 1;
                    nextRow++;
                } else {
                    nextColumn = 2;
                }
                break;
        }
        return `${exercise.key}_p${nextColumn}_${nextRow}`;
    }

    getAddSetButton() {
        const { dispatch, block, exercise, published } = this.props;

        if (!exercise) {
            return null;
        }

        const buttonDisabled = exercise.param_count === 10 || published;
        const color = buttonDisabled ? '#AFAFAF' : '#0A0EFF';
        return (
            <IconButton
                size="small"
                style={{
                    color: color,
                    border: '2px solid',
                    width: 24,
                    height: 24,
                    marginLeft: 8
                }}
                disabled={buttonDisabled}
                onClick={() => {
                    const newParamCount = exercise.param_count + 1;
                    if (newParamCount > 10) {
                        return;
                    }
                    DesignerState.updateSetNum(
                        dispatch,
                        block,
                        exercise,
                        newParamCount
                    );
                }}
            >
                <AddIcon style={{ width: 16, height: 18 }} />
            </IconButton>
        );
    }

    getRemoveSetButton() {
        const { dispatch, block, exercise, published } = this.props;

        if (!exercise) {
            return null;
        }

        const buttonDisabled = exercise.param_count === 0 || published;
        const color = buttonDisabled ? '#AFAFAF' : '#0A0EFF';
        return (
            <IconButton
                style={{
                    color: color,
                    border: '2px solid',
                    width: 24,
                    height: 24,
                    marginRight: 8
                }}
                disabled={buttonDisabled}
                onClick={() => {
                    const newParamCount = exercise.param_count - 1;
                    if (newParamCount < 0) {
                        return;
                    }

                    DesignerState.updateSetNum(
                        dispatch,
                        block,
                        exercise,
                        newParamCount
                    );
                }}
            >
                <RemoveIcon style={{ width: 16, height: 18 }} />
            </IconButton>
        );
    }

    render() {
        Console.render('designer.RepTable');
        let { exercise, published } = this.props;
        let noSets = exercise ? exercise.no_sets === 1 : false;

        let rows = [];
        let types = null;
        if (exercise) {
            if (!noSets) {
                for (let i = 1; i <= exercise.param_count; i++) {
                    let paramKey1 = 'param_1_data_' + i;
                    let paramKey2 = 'param_2_data_' + i;
                    rows.push(
                        <li
                            className="exercise-table-row layout-row"
                            key={'row' + i}
                        >
                            <div className="table-input-num">{i}</div>
                            <input
                                type="text"
                                className="table-input"
                                disabled={exercise.param_1_type === 0}
                                ref={exercise.key + '_p1_' + i}
                                onClick={this.selectOnClick}
                                onChange={event =>
                                    this.updateValue(
                                        event,
                                        exercise.param_1_type,
                                        paramKey1,
                                        1,
                                        i
                                    )
                                }
                                onKeyDown={e => this.onKeyDown(e, 'p1', i)}
                                value={exercise[paramKey1]}
                            />
                            <input
                                type="text"
                                className="table-input"
                                disabled={exercise.param_2_type === 0}
                                ref={exercise.key + '_p2_' + i}
                                onKeyDown={e => this.onKeyDown(e, 'p2', i)}
                                onClick={this.selectOnClick}
                                onChange={event =>
                                    this.updateValue(
                                        event,
                                        exercise.param_2_type,
                                        paramKey2,
                                        2,
                                        i
                                    )
                                }
                                value={exercise[paramKey2]}
                            />
                        </li>
                    );
                }
            }

            let numSetOptions = [
                { value: 1, title: '1 Set' },
                { value: 2, title: '2 Sets' },
                { value: 3, title: '3 Sets' },
                { value: 4, title: '4 Sets' },
                { value: 5, title: '5 Sets' },
                { value: 6, title: '6 Sets' },
                { value: 7, title: '7 Sets' },
                { value: 8, title: '8 Sets' },
                { value: 9, title: '9 Sets' },
                { value: 10, title: '10 Sets' }
            ];

            let paramTypeRef = this.props.paramTypeRef;
            let paramTypeRef2 = [...this.props.paramTypeRef];
            paramTypeRef2[0].title = exercise.param_2_type ? '-' : 'Optional';
            types = (
                <li className="exercise-table-row layout-row">
                    <div className="table-header-num">
                        <DropSimple
                            value={exercise.param_count}
                            placeholder="# Sets"
                            labelKey="title"
                            clearable={false}
                            searchable={false}
                            openOnFocus={true}
                            options={numSetOptions}
                            ref={el => (this.$setsDrop = el)}
                            onChange={this.changeExSetCount.bind(this)}
                        />
                    </div>

                    <DropSimple
                        value={exercise.param_1_type}
                        valueKey="id"
                        labelKey="title"
                        className="table-select float-left"
                        placeholder="Type"
                        clearable={false}
                        searchable={false}
                        onChange={value => this.updateParamType(1, value)}
                        options={paramTypeRef}
                    />
                    <DropSimple
                        value={exercise.param_2_type}
                        valueKey="id"
                        labelKey="title"
                        className="table-select float-left"
                        placeholder="Type"
                        clearable={false}
                        searchable={false}
                        onChange={value => this.updateParamType(2, value)}
                        options={paramTypeRef2}
                    />
                </li>
            );
        }

        const addButton = this.getAddSetButton();
        const removeButton = this.getRemoveSetButton();
        const addRemoveButtonStyles = {
            textAlign: 'center',
            fontSize: 12,
            fontWeight: 800,
            padding: 8,
            color: published ? '#AFAFAF' : '#1f242a',
            marginLeft: 68
        };

        return (
            <div className="exercise-table">
                <ul>
                    {types}
                    {rows}
                </ul>
                <div style={addRemoveButtonStyles}>
                    {removeButton} Sets {addButton}
                </div>
            </div>
        );
    }
}

let mapStateToProps = function(state, ownProps) {
    const published =
        ownProps.workoutId &&
        state.calendar.sessionTree[ownProps.workoutId].data.published;
    return {
        ...ownProps,
        published: published,
        exercise: state.calendar.exerciseTree[ownProps.exercise.key],
        schemeUpdated:
            state.calendar.uiTree.schemeUpdated === ownProps.exercise.key,
        paramTypeRef: state.library.paramTypeRef
    };
};
RepTable = connect(mapStateToProps)(RepTable);



// WEBPACK FOOTER //
// ./src/view/designer/components/RepTable.jsx